<template>
  <v-card flat>
    <v-card-title class="d-flex align-center pe-2">
      <SelectorKPI
        v-model="selectedKPIs"
        autoload
        multiple
        :label="'Select KPIs'"
        :help-text="'Select KPIs for the extra analytics'"
      />
    </v-card-title>

    <v-divider></v-divider>
    <v-data-table
      v-model:search="search"
      :filter-keys="['name']"
      :headers="headers"
      :items="selectedKPIs"
    >
      <template v-slot:item.image="{ item }">
        <v-card class="my-2" elevation="2" rounded>
          <v-img
            :src="`https://cdn.vuetifyjs.com/docs/images/graphics/gpus/${item.image}`"
            height="64"
            cover
          ></v-img>
        </v-card>
      </template>

      <template v-slot:item.value="{ item }">
        <span v-if="item.unit === '$'">
          {{ formatPrice(getValue(item)?.value || 0) }}
        </span>
        <span v-else-if="item.unit === 'count'">
          {{ formatNumber(getValue(item)?.value || 0) }}
        </span>
        <span v-else-if="item.unit === '%'">
          {{ formatPercent(getValue(item)?.value || 0) }} %
        </span>

        <span v-else> {{ item.value || 0 }} {{ item.unit }} </span>
      </template>

      <template v-slot:item.goal="{ item }">
        <span v-if="item.unit === '$'">
          {{ formatPrice(getGoal(item)?.value || 0) }}
        </span>
        <span v-else-if="item.unit === 'count'">
          {{ formatNumber(getGoal(item)?.value || 0) }}
        </span>
        <span v-else-if="item.unit === '%'">
          {{ formatPercent(getGoal(item)?.value || 0) }} %
        </span>

        <span v-else> {{ item.value || 0 }} {{ item.unit }} </span>
      </template>

      <template v-slot:item.stock="{ item }">
        <v-chip
          :color="item.stock ? 'green' : 'red'"
          :text="item.stock ? 'In stock' : 'Out of stock'"
          class="text-uppercase"
          :prepend-icon="'mdi-alert-outline'"
          size="small"
          label
        ></v-chip>
      </template>
    </v-data-table>
  </v-card>
</template>


<script>
import SelectorKPI from "../../atoms/common/autocompletes/SelectorKPI.vue";
import { CampaignAPIInstance } from "@/api";
import { FormatterHelper } from "@/helpers/formatter.helper";

export default {
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    SelectorKPI,
  },
  data() {
    return {
      search: "",
      selectedKPIs: [],
      goalsProgress: [],
      headers: [
        { title: "Name", value: "name" },
        { title: "Value", value: "value", minWidth: 80 },
        { title: "Goal", value: "goal", minWidth: 80 },
        { title: "Status", value: "stock" },
        { title: "Example", value: "formulaExample", maxWidth: 200 },
      ],
    };
  },
  watch: {
    modelValue: {
      handler() {
        this.setDefaults();
      },
      deep: true,
    },
    selectedKPIs: {
      handler() {
        this.getGoalsProgress();
      },
      deep: true,
    },
  },
  created() {
    this.setDefaults();
  },
  methods: {
    formatNumber(num) {
      if (num === "N/A" || num===undefined) return 'N/A';
      return FormatterHelper.formatNumber(num) ;
    },
    formatPrice(num) {
      return num !== "N/A" ? FormatterHelper.price(num) : num;
    },
    formatPercent(num) {
      return num !== "N/A" ? FormatterHelper.priceCustom(num, 2) : num;
    },
    setDefaults() {
      if (this.modelValue && this.modelValue.Goals) {
        this.selectedKPIs = this.modelValue.Goals.map((goal) => ({
          ...goal.KPI,
          value: goal.value,
        }));
      }
    },
    getGoal(kpi) {
      if (!this.modelValue.Goals) return;

      const found = this.modelValue.Goals.find(
        (goal) => goal.KPI.code === kpi.code
      );

      return found;
    },
    getValue(kpi) {
      if (!this.modelValue.Goals) return;

      const found = this.goalsProgress.find(
        (progress) => progress.KPI.code === kpi.code
      );

      return found;
    },
    async getGoalsProgress() {
      if (!(this.selectedKPIs && this.selectedKPIs.length)) return;

      const { data } = await CampaignAPIInstance.Analytics.goalsProgress(
        this.modelValue.id,
        [...this.selectedKPIs.map((kpi) => kpi.code)]
      );
      this.goalsProgress = data;
    },
  },
};
</script>